module.exports = __webpack_public_path__ + "assets/button.43a072f1.svg";